import React from "react";
import { Quill } from "react-quill";
import QuillMarkdown from "quilljs-markdown";
import Table from "quill-table";

const Size = Quill.import("formats/size");
Size.whitelist = ["extra-small", "small", "medium", "large"];
Quill.register(Size, true);
const Font = Quill.import("formats/font");
Font.whitelist = ["arial", "comic-sans", "courier-new", "georgia", "helvetica", "lucida"];
Quill.register(Font, true);
Quill.register("modules/markdownOptions", QuillMarkdown);
Quill.register({
  "modules/table": Table,
});
const Header = Quill.import("formats/header");
class CustomHeader extends Header {
  static ids = ["procedure steps", "responsibilities", "definitions", "scope", "purpose"];
  static resetid = [...CustomHeader.ids];

  static create(value) {
    let node = super.create(value);
    if (value === 2) {
      if (!CustomHeader.ids.length) {
        CustomHeader.ids = [...CustomHeader.resetid];
      }
      let id = CustomHeader.ids.pop() || "extra";
      node.setAttribute("id", id);
    }
    return node;
  }
}
Quill.register(CustomHeader, true);


const Clipboard = Quill.import("modules/clipboard");
class CustomClipboard extends Clipboard {
  onPaste(e) {
    e.preventDefault(); 
    const scrollPos = this.quill.root.scrollTop;
    const clipboardData = e.clipboardData || window.clipboardData;
    const text = clipboardData.getData("text/plain");
    const range = this.quill.getSelection();
    if (range) {
      this.quill.insertText(range.index, text);
      this.quill.setSelection(range.index + text.length, 0);
    }
    setTimeout(() => {
      this.quill.root.scrollTop = scrollPos;
    }, 0);
  }
}
Quill.register("modules/clipboard", CustomClipboard, true);

export const formats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "align",
  "strike",
  "script",
  "blockquote",
  "background",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "color",
  "code-block",
];

export const uuidToAlphabetical = (uuid) => {
  const hexToCharMap = {
    0: "a",
    1: "b",
    2: "c",
    3: "d",
    4: "e",
    5: "f",
    6: "g",
    7: "h",
    8: "i",
    9: "j",
    a: "k",
    b: "l",
    c: "m",
    d: "n",
    e: "o",
    f: "p",
    "-": "-",
  };

  return uuid
    ?.split("")
    .map((char) => {
      if (char === "-") return "-";
      return hexToCharMap[char] || "";
    })
    .join("");
};

export const alphabeticalToUuid = (alphabeticalString) => {
  const charToHexMap = {
    a: "0",
    b: "1",
    c: "2",
    d: "3",
    e: "4",
    f: "5",
    g: "6",
    h: "7",
    i: "8",
    j: "9",
    k: "a",
    l: "b",
    m: "c",
    n: "d",
    o: "e",
    p: "f",
    "-": "-",
  };

  return alphabeticalString
    .split("")
    .map((char) => {
      if (char === "-") return "-";
      return charToHexMap[char] || "";
    })
    .join("");
};

export const QuillToolbar = ({ id, show }) => {
  return (
    <div className={`myToolbar ${show ? "" : "hide"}`}>
      <div id={id}>
        <span className="ql-formats">
          {/* <select className="ql-font" defaultValue="arial">
            <option value="arial">Arial</option>
            <option value="comic-sans">Comic Sans</option>
            <option value="courier-new">Courier New</option>
            <option value="georgia">Georgia</option>
            <option value="helvetica">Helvetica</option>
            <option value="lucida">Lucida</option>
          </select> */}
          <select className="ql-size" defaultValue="medium">
            <option value="extra-small">Size 1</option>
            <option value="small">Size 2</option>
            <option value="medium">Size 3</option>
            <option value="large">Size 4</option>
          </select>
          <select className="ql-header" defaultValue="3">
            <option value="1">Heading</option>
            <option value="2">Subheading</option>
            <option value="3">Normal</option>
          </select>
        </span>
        <span className="ql-formats">
          <button className="ql-bold" />
          <button className="ql-italic" />
          <button className="ql-underline" />
          {/* <button className="ql-strike" /> */}
        </span>
        <span className="ql-formats">
          <button className="ql-list" value="ordered" />
          <button className="ql-list" value="bullet" />
          <button className="ql-indent" value="-1" />
          <button className="ql-indent" value="+1" />
        </span>
        <span className="ql-formats">
          <button className="ql-script" value="super" />
          <button className="ql-script" value="sub" />
          <button className="ql-blockquote" />
          <button className="ql-direction" />
        </span>
        <span className="ql-formats">
          <select className="ql-align" />
          <select className="ql-color" />
          <select className="ql-background" />
        </span>
        <span className="ql-formats">
          <button className="ql-link" />
          <button className="ql-image" />
          {/* <button className="ql-video" /> */}
        </span>
        <span className="ql-formats">
          {/* <button className="ql-formula" /> */}
          <button className="ql-code-block" />
          {/* <button className="ql-clean" /> */}
        </span>
        {/* Undo */}
        {/* <span title="Undo">
          <button className="ql-undo" onClick={handleUndo}>
            Undo
          </button>
        </span> */}
        {/* <span title="Redo">
          <button className="ql-redo" onClick={handleRedo}>
           Redo
          </button>
        </span> */}
      </div>
    </div>
  );
};

export default QuillToolbar;
